import React from "react";
import { Container, Row, Col, Card, Button, ButtonGroup } from "reactstrap";
import { connect } from "react-redux";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import { elementActions } from "../../../../../store/actions/cms/element/element.action";
import ReactDragList from "react-drag-list";
import "react-drag-list/assets/index.css";
import { Droppable, Draggable } from "react-beautiful-dnd";
import { renderElement } from "../../../../helpers/renderElement";
import FloatingActionButtons from "../../../../components/UI/Buttons/FloatingActionButtons";
import ElementWrapper from "../../../../components/element/ElementWrapper/ElementWrapper";
import styled from "styled-components";
import { elementConstants } from "../../../../../constants/cms/form/element/element.constants";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { insertGoogleFonts } from "../../../../../helpers/fontHelper";
import { labelAlignmentButtonDisplay } from "../../../../helpers/labelAlignment";
import JirangoButton from "../../../../components/UI/Buttons/JirangoButton";
import ConditionModal from "../../conditions/components/ConditionModal";
import { deepClone } from "../../../../../helpers/objectHelper";
import { securityHelper } from "../../../../../helpers/securityHelper";
import { ElementOverlay } from "../../../../components/element/Overlay/ElementOverlay";

import Media from "react-media";
import { arrayHelper } from "../../../../../helpers/arrayHelper";
import InheritageWrapper from "../../../../components/editor/tools/Inheritage/InheritageWrapper";

const DropArea = styled.div`
  background-color: ${(props) => props.isDraggingOver && "#20a8d85c"};
  padding-top: ${(props) => props.isDraggingOver && props.hasChildren && !props.isDropZoneDisabled && "200px"};
  padding-bottom: ${(props) => props.isDraggingOver && props.hasChildren && !props.isDropZoneDisabled && "200px"};

  padding: ${(props) => "20px 0px"};
  border: ${(props) => props.isDraggingOver && "1px dashed #20a8d8"};
`;

const DragContainer = styled.div`
  background-color: ${(props) => props.isDragging && "#e7f9ff"};
  background-color: ${(props) => props.backgroundColor};
  box-shadow: ${(props) => props.isDragging && "box-shadow:0 8px 6px -6px black"};
`;
class FormContent extends React.Component {
  state = {
    template: null,
    formElements: null,
    isDropZoneDisabled: false,
    isMediaVaultOpen: false,
    isConditionModalOpen: false,
  };
  componentDidMount() {
    document.addEventListener("click", this.handleClick, false);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClick, false);
  }
  handleClick = (e) => {
    if (
      this.elementContainerRef.contains(e.target) ||
      (this.props.asideEditorRef && this.props.asideEditorRef.contains(e.target)) ||
      (this.props.sidebarRef && this.props.sidebarRef.contains(e.target))
    ) {
      return;
    } else if (this.props.isConditionModalOpen) {
      return;
    } else if (this.props.cms.deselectionBlocked) {
      return;
    } else {
      this.onDeselect();
    }
  };

  togglePage = (page) => {
    const { dispatch } = this.props;
    const { form } = this.props;
    if (page <= form.pages || page >= 1) {
      dispatch(formActions.deselect(page));
      dispatch(formActions.scrollPage(page));
    }
  };

  handleOrderChange(event, dataSource) {
    const { dispatch } = this.props;
    const reArranged = [...dataSource];
    dataSource.map((o, index) => {
      reArranged[index].sortOrder = index + 1;
    });
    dispatch(formActions.softUpdate(reArranged));
  }
  onSelect = (element) => {
    const { dispatch } = this.props;
    /*  this.containerAdjustedSelection(); */
    dispatch(formActions.select(element));
  };
  onDelete = (element) => {
    const { dispatch } = this.props;
    dispatch(formActions.remove(element));
  };
  onTransfer = (element, page) => {
    const { dispatch } = this.props;
    element.page = page;
    dispatch(elementActions.update(element));
    dispatch(formActions.deselect());
  };
  addPage = () => {
    const { dispatch } = this.props;
    dispatch(formActions.addPage());
  };
  scrollPage = (page) => {
    const { dispatch } = this.props;
    const { form } = this.props;
    if (page <= form.pages || page >= 1) {
      dispatch(formActions.deselect(page));
      dispatch(formActions.scrollPage(page));
    }
  };
  onDeselect = () => {
    const { dispatch } = this.props;
    dispatch(formActions.deselect());
  };
  disableDropZone = (isDisabled) => {
    this.setState({ isDropZoneDisabled: isDisabled });
  };
  onImageChange = (el) => {
    this.setState({ isMediaVaultOpen: true });
  };
  isDragging = (props) => {};
  updateConditions = (conditions) => {
    const { selectedContainer, selectedElement } = this.props.form;
    let obj = selectedContainer || selectedElement;
    let selected = Object.assign({}, obj);
    selected.data.conditions = Array.from(conditions);

    this.props.dispatch(elementActions.update(selected));
    this.props.toggleConditionModal();
  };
  containerAdjustedSelection = () => {
    if (this.props.form.selectedContainer) {
      const containerId = this.props.form.selectedContainer.id;
      const containerChildId = this.props.form.formElements
        .filter((el) => {
          return el.parentId === containerId;
        })
        .map((el) => {
          return el.id;
        });
      /*    if (containerChildId.includes(this.props.form.selectedElement.parentId)) {
         } */
    }
  };
  sortElements = () => {
    const { form } = this.props;
    const { formElements } = this.props.form;
    if (formElements === undefined || formElements.length < 1) return [];

    const dataSource = Array.from(
      formElements
        .filter((el) => {
          return el.page === form.currentPage && el.parentId === null;
        })
        .sort((a, b) => {
          return a.sortOrder - b.sortOrder;
        })
    );
    let finishedList = this.sortController(dataSource);
    return finishedList;
  };
  sortController = (list) => {
    const controlledList = Array.from(list);
    for (let index = 0; index < controlledList.length; index++) {
      if (controlledList[index].sortOrder !== index) {
        controlledList[index].sortOrder = index;
      }
    }
    return controlledList;
  };
  shouldRenderEmptyDivider = () => {};
  selectedBorderStyle = (el) => {
    if (el.type === elementConstants.CONTAINER) return "1px solid #28a74563";
    else return "1px solid #5593dc94";
  };
  handleKeyDown = (e) => {
    const keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
      // You code when "Enter" is pressed
      if (this.state.optValue) {
        this.handleChange(e.target.value);
        this.addOptions();
      }
    }
  };
  render() {
    //Add to method
    const { form /* template */, cms } = this.props;
    const { template, previewDevice } = this.props.template;
    const { formElements, selectedElement, selectedContainer } = this.props.form;
    const dataSource = this.sortElements();
    const dataSourceX = Array.from(
      formElements
        .filter((el) => {
          return el.page === form.currentPage;
        })
        .sort((a, b) => {
          return a.sortOrder - b.sortOrder;
        })
    );
    /*     console.table(dataSourceX.map(m => { return { sortOrder: m.sortOrder, type: m.type, parentId: m.parentId } })) */

    return (
      <div className="target">
        <div className="animated fadeIn">
          <div ref={(r) => (this.elementContainerRef = r)}>
            <Droppable isDropDisabled={this.state.isDropZoneDisabled} droppableId="content">
              {(provided, snapshot) => {
                return (
                  <DropArea
                    {...provided.droppableProps}
                    isDraggingOver={snapshot.isDraggingOver}
                    isDropZoneDisabled={this.state.isDropZoneDisabled}
                    id="element-container"
                    ref={/* (r) => { this.elementContainerRef = r; */ provided.innerRef /* (r)  */}
                  >
                    {dataSource.map((el, index) => {
                      return (
                        <div className="animated fadeIn" key={index}>
                          <Draggable key={index} draggableId={el.contentId} index={index}>
                            {(provided, snapshot) => (
                              <DragContainer
                                {...provided.draggableProps}
                                {...this.props}
                                ref={provided.innerRef}
                                isDragging={snapshot.isDragging}
                                backgroundColor={template.content.content.backgroundColor}
                                hasChildren={dataSource.length > 0}
                              >
                                <div
                                  style={{
                                    minHeight: el.type === elementConstants.CONTENT && el.props.type === "IMG" ? "200px" : "auto",
                                  }}
                                  className="element-container"
                                >
                                  { el.eventId != cms.eventId && el.props && el.props.inherit !== undefined ? <InheritageWrapper onClick={() => this.onSelect(el)} status={el.props.inherit} /> : null}
                                  <Row
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      margin: "0px",
                                    }}
                                  >
                                    <Col
                                      style={{
                                        width: "100%",
                                        /*      display: "inline-flex", */

                                        padding: "0px",
                                        border:
                                          (selectedElement && el.contentId === selectedElement.contentId) || (form.selectedContainer && el.contentId === form.selectedContainer.contentId)
                                            ? this.selectedBorderStyle(el)
                                            : "1px solid transparent",
                                        minHeight: el.type === elementConstants.CONTENT && el.props.type === "IMG" ? "200px" : "auto",
                                      }}
                                    >
                                      <Col
                                        style={{
                                          maxWidth: "100%",
                                          backgroundColor: "inherit",
                                          padding: "0px",
                                        }}
                                        onClick={() => this.onSelect(el)}
                                      >
                                        {renderElement(
                                          !el.props &&
                                            el.type != elementConstants.INVOICE_FIELD &&
                                            el.type != elementConstants.PAYMENT_OPTIONS &&
                                            el.type != elementConstants.CONTAINER &&
                                            el.type != elementConstants.PROFILEIMAGE_UPLOAD &&
                                            el.type != elementConstants.PRE_CONFIRMATION &&
                                            el.type != elementConstants.DISCOUNT &&
                                            el.type != elementConstants.GROUP_REGISTRATION && 
                                            el.type != elementConstants.FILE_UPLOADER
                                            ? elementConstants.DELETED
                                            : el.type,
                                          el,
                                          this.disableDropZone
                                        )}
                                      </Col>
                                      <ElementOverlay
                                        selectedContainer={form.selectedContainer}
                                        targetElement={el}
                                        dragHandleProps={provided.dragHandleProps}
                                        selectedElement={form.selectedElement}
                                        onDelete={this.onDelete}
                                      />
                                    </Col>

                                    <div {...provided.dragHandleProps} style={{ display: "none" }} />
                                  </Row>
                                </div>
                              </DragContainer>
                            )}
                          </Draggable>
                          {(dataSource[index + 1] !== undefined && dataSource[index + 1].type) || el.type === elementConstants.CONTAINER ? <div style={{ height: "0px", width: "100%" }} /> : null}
                        </div>
                      );
                    })}

                    {dataSource && dataSource !== undefined && dataSource.length < 1 ? (
                      !this.state.isDropZoneDisabled && (
                        <div
                          style={{
                            height: "200px",
                            border: "2px dotted #0000000f",
                          }}
                        >
                          {provided.placeholder}
                        </div>
                      )
                    ) : (
                      <div>{provided.placeholder}</div>
                    )}
                  </DropArea>
                );
              }}
            </Droppable>

            {form.currentPage === form.pages &&
            form.pages === 1 &&
            form.settings !== undefined &&
            form.settings.submit !== undefined &&
            form.settings.submit.labels !== undefined &&
            !form.settings.submit.hidden /* .find(l => {
                return l.languageCode === form.languageCode;
              }).text !== "" */ ? (
              <Row
                style={{
                  ...labelAlignmentButtonDisplay(form.settings.submit.alignment),
                  display: "inline-flex",
                  /*    padding: "10px", */
                  width: "100%",
                  margin: "0px",
                }}
              >
                <Col
                  style={{
                    ...labelAlignmentButtonDisplay(form.settings.submit.alignment),
                    padding: "0px",
                    display: "inline-flex",
                  }}
                >
                  <div>
                    <JirangoButton style={template && template.content.button}>
                      {
                        /*    form.settings !== undefined &&
                               form.settings.submit !== undefined &&
                               form.settings.submit.labels !== undefined && */
                        form.settings.submit.labels.find((l) => {
                          return (l.languageCode.code || l.languageCode) === form.languageCode;
                        }).text !== ""
                          ? form.settings.submit.labels.find((l) => {
                              return (l.languageCode.code || l.languageCode) === form.languageCode;
                            }).text
                          : form.settings.submit.defaultLabel
                      }
                    </JirangoButton>
                  </div>
                </Col>
              </Row>
            ) : null}

            {form && form.pages > 1 ? (
              <Row
                style={{
                  display: "inline-flex",
                  padding: "10px",
                  width: "100%",
                  margin: "0px",
                }}
              >
                <Col style={{ textAlign: "left", padding: "0px" }}>
                  {form.currentPage > 1 && form.settings !== undefined && form.settings.navigation !== undefined && form.settings.navigation.previous !== undefined ? (
                    <JirangoButton onClick={() => this.togglePage(form.currentPage - 1)} style={template && template.content.button}>
                      {form.settings.navigation.previous.labels.find((l) => {
                        return (l.languageCode.code || l.languageCode) === form.languageCode;
                      }).text.length > 0 ? (
                        form.settings.navigation.previous.labels.find((l) => {
                          return (l.languageCode.code || l.languageCode) === form.languageCode;
                        }).text
                      ) : (
                        <i className="fa fa-chevron-left" />
                      )}
                    </JirangoButton>
                  ) : null}
                </Col>

                <Col style={{ textAlign: "right", padding: "0px" }}>
                  {form.currentPage < form.pages && form.settings !== undefined && form.settings.navigation !== undefined && form.settings.navigation.next !== undefined ? (
                    <JirangoButton onClick={() => this.togglePage(form.currentPage + 1)} style={template && template.content.button}>
                      {form.settings.navigation.next.labels.find((l) => {
                        return (l.languageCode.code || l.languageCode) === form.languageCode;
                      }).text !== "" ? (
                        form.settings.navigation.next.labels.find((l) => {
                          return (l.languageCode.code || l.languageCode) === form.languageCode;
                        }).text
                      ) : (
                        <i className="fa fa-chevron-right" />
                      )}
                    </JirangoButton>
                  ) : null}
                  {form.currentPage === form.pages && form.settings !== undefined && form.settings.submit !== undefined && form.settings.submit.labels !== undefined && !form.settings.submit.hidden ? (
                    <JirangoButton style={template && template.content.button}>
                      {form.settings.submit.labels.find((l) => {
                        return (l.languageCode.code || l.languageCode) === form.languageCode;
                      }).text !== ""
                        ? form.settings.submit.labels.find((l) => {
                            return (l.languageCode.code || l.languageCode) === form.languageCode;
                          }).text
                        : form.settings.submit.defaultLabel}
                    </JirangoButton>
                  ) : null}
                </Col>
              </Row>
            ) : null}
          </div>

          {this.props.isConditionModalOpen && this.props.cms.editMode && selectedElement ? (
            <ConditionModal
              show={this.props.isConditionModalOpen}
              conditionAction={this.props.conditionAction}
              selectedElement={selectedElement}
              // conditions={element.data.conditions}
              toggle={this.props.toggleConditionModal}
              update={this.updateConditions}
              languageCode={this.props.cms.languageCode}
              sourceList={
                form &&
                form.formElements.filter((fe) => {
                  return fe.contentId !== selectedElement.contentId /* &&
                      fe.page === selectedElement.page */;
                })
              }
            />
          ) : null}
          {this.props.isConditionModalOpen && this.props.cms.editMode && selectedContainer ? (
            <ConditionModal
              show={this.props.isConditionModalOpen}
              conditionAction={this.props.conditionAction}
              selectedElement={selectedContainer}
              // conditions={element.data.conditions}
              toggle={this.props.toggleConditionModal}
              update={this.updateConditions}
              languageCode={this.props.cms.languageCode}
              sourceList={
                form &&
                form.formElements.filter((fe) => {
                  return fe.contentId !== selectedContainer.contentId /* &&
                      fe.page === selectedElement.page */;
                })
              }
            />
          ) : null}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    alert: state.alert,
    form: state.form,
    template: state.template,
    cms: state.cms,
  };
}

export default connect(mapStateToProps)(FormContent);
